import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import TextField from '@material-ui/core/TextField';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import { Grid } from 'semantic-ui-react';

class EditPurchaserAddress extends React.Component {
  state = {
    error: '',
    load: false,
    message: '',
  };

  componentDidMount() {
    this.setState({
      name: this.props.editname,
      mobile: this.props.editmobile,
      designation: this.props.editdesignation,
      email: this.props.editmail,
      id: this.props.editid,
    });
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit() {
    let context = this;
    let name = this.state.name;
    let mobile = this.state.mobile;
    let designation = this.state.designation;
    let email = this.state.email;
    let id = this.state.id;
    if (name == '' || name == undefined || name == null) {
      context.setState({
        error: 'Enter the Name!!!'
      })
      return;
    }
    if (mobile == '' || mobile == undefined || mobile == null) {
      context.setState({
        error: 'Enter the Mobile!!!'
      })
      return;
    }
    if (designation == '' || designation == undefined || designation == null) {
      context.setState({
        error: 'Enter the Designation!!!'
      })
      return;
    }
    if (email == '' || email == undefined || email == null) {
      context.setState({
        error: 'Enter the Email!!!'
      })
      return;
    }
    context.setState({
      load: true,
      message: 'Add Purchaser!!!'
    })
    let data1 = { 'purchaser_id': id, 'name': name, 'mobile': mobile, 'designation': designation, 'email': email };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'purchaser/editpurchasercontact.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.getPurchaserContact();
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false,
        });
      }
    });
  }

  render() {
    const { fullScreen } = this.props;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog
          fullScreen={fullScreen}
          open={this.props.editPurchaserContact}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle style={{width: 500}} id="responsive-dialog-title">{"Edit Contact"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <form noValidate autoComplete="off">
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="Name"
                      value={this.state.name}  onChange={this.handleChange('name')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="Mobile"
                      value={this.state.mobile}  onChange={this.handleChange('mobile')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="Designation"
                      value={this.state.designation}  onChange={this.handleChange('designation')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <TextField
                      id="outlined-name" label="email"
                      value={this.state.email}  onChange={this.handleChange('email')}
                      margin="normal" variant="outlined" fullWidth />
                  </Grid.Column>
                </Grid>
              </form>
              <center style={{color: 'red'}}>{this.state.error}</center>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.handleClose} color="secoundary">
              Cancel
            </Button>
            <Button onClick={this.submit.bind(this)} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

EditPurchaserAddress.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(EditPurchaserAddress);
